
import { Load } from '../../types';

// Second floor loads
export const secondFloorLoads: Load[] = [
  {
    id: '4',
    name: 'Server Room Cooling',
    type: 'cooling',
    status: true,
    location: 'Server Room',
    powerRating: '1800W',
    currentConsumption: '1650W',
    schedules: [
      {
        id: '4-1',
        days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
        startTime: '00:00',
        endTime: '23:59',
        enabled: true,
      }
    ],
    recommendations: [
      {
        id: '4-rec-1',
        description: 'Optimize server room temperature (raise by 2°C)',
        potentialSavings: '180kWh/month',
        priority: 'medium'
      },
      {
        id: '4-rec-2',
        description: 'Implement hot/cold aisle containment',
        potentialSavings: '360kWh/month',
        priority: 'high'
      }
    ]
  },
  {
    id: '8',
    name: 'Lab Equipment',
    type: 'computing',
    status: true,
    location: 'Research Lab',
    powerRating: '2200W',
    currentConsumption: '1950W',
    schedules: [
      {
        id: '8-1',
        days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        startTime: '08:00',
        endTime: '20:00',
        enabled: true,
      }
    ],
    recommendations: [
      {
        id: '8-rec-1',
        description: 'Schedule equipment maintenance to optimize efficiency',
        potentialSavings: '220kWh/month',
        priority: 'high'
      }
    ]
  },
  {
    id: '9',
    name: 'Development Area Lighting',
    type: 'lighting',
    status: true,
    location: 'Development',
    powerRating: '350W',
    currentConsumption: '320W',
    schedules: [
      {
        id: '9-1',
        days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        startTime: '07:00',
        endTime: '19:00',
        enabled: true,
      }
    ],
    recommendations: [
      {
        id: '9-rec-1',
        description: 'Replace with energy-efficient LED panels',
        potentialSavings: '70kWh/month',
        priority: 'medium'
      }
    ]
  }
];
